import React, { useContext } from 'react';
import { ScrollElement } from '@prisjakt/ui-scroll';
import { AppContext } from '@prisjakt/ui-app-context';
import ProductProperties from '../product-properties';
import { basicInfo, getScrollLinkOffset } from '../../utils';
import { Product } from '../../../../types';

const ProductTabProperties: React.FC<IProductTabPropertiesProps> = props => {
  const { product } = props;
  const { t } = useContext(AppContext);
  const productInfo = basicInfo(product, t);

  return (
    <ScrollElement name="Product Properties" data-test="PropertiesTabContent">
      <ProductProperties
        basicInfo={productInfo}
        properties={product.properties || undefined}
        description={product.description || undefined}
        getScrollLinkOffset={getScrollLinkOffset}
      />
    </ScrollElement>
  );
};

interface IProductTabPropertiesProps {
  product: Product;
}

export default ProductTabProperties;
